import React, { Component } from 'react';
import { Modal } from 'reactstrap';
import Swal from "sweetalert2/dist/sweetalert2.js";
import Select from "react-select";
import FormCreate from './FormCreate';

// Modal de configuracion del "Reporte de matrices por periodo": define de que
// formato hijo salen los registros diarios, que preguntas del padre van en la
// cabecera y que matrices se transponen (con su abreviatura por columna).
// Lee la respuesta con tolerancia: si el servidor devuelve HTML (500, timeout,
// sesion vencida) se reporta el status en vez de reventar con SyntaxError.
async function readJson(res) {
    const text = await res.text();
    try {
        return JSON.parse(text);
    } catch (e) {
        return { __httpError: true, status: res.status, success:
            res.status === 500 ? "Error del servidor (500). Si acabas de desplegar, revisa que las migraciones se hayan ejecutado."
                               : `El servidor respondió ${res.status}`, type: "error" };
    }
}

class Index extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            isLoaded: true,
            showForm: false,
            modeEdit: false,
            editRegister: null,
            expandedId: null,

            parentQuestions: [],
            childMatrices: [],
            childSteps: [],
            newFieldQuestion: null,
            newFieldLabel: "",
            newMatrixQuestion: null,
        };
    }

    componentDidMount = () => {
        this.loadData();
        this.loadParentQuestions();
    }

    messageSuccess = (response) => {
        Swal.fire({
            position: "center", type: `${response.type}`, title: `${response.success}`,
            showConfirmButton: false, timer: 1500,
        });
    };

    loadData = () => {
        fetch(`/formatos/get_format_matrix_reports/${this.props.format.id}`, {
            method: 'GET',
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
        .then(readJson)
        .then(data => this.setState({ data: data.data, isLoaded: false }));
    }

    loadParentQuestions = () => {
        fetch(`/formatos/data_questions/${this.props.format.id}`, {
            method: 'GET',
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
        .then(readJson)
        .then(data => {
            const list = (data.steps_questions || data.register || []);
            this.setState({ parentQuestions: list.map(q => ({ label: q.question, value: q.id })) });
        });
    }

    loadChildMatrices = (childFormatId) => {
        fetch(`/formatos/get_matrix_report_child_matrices/${childFormatId}`, {
            method: 'GET',
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
        .then(readJson)
        .then(data => this.setState({ childMatrices: data.matrices || [], childSteps: data.steps || [] }));
    }

    handleCreated = (register) => {
        this.setState({
            data: [...this.state.data, register],
            showForm: false, modeEdit: false, editRegister: null, expandedId: register.id,
        });
        this.loadChildMatrices(register.child_format_id);
    }

    handleUpdated = (register) => {
        this.setState({
            data: this.state.data.map(item => item.id === register.id ? register : item),
            showForm: false, modeEdit: false, editRegister: null,
        });
    }

    handleDelete = (id) => {
        Swal.fire({
            title: "¿Estás seguro?", text: "¡La configuración será eliminada!",
            type: "warning", showCancelButton: true,
            confirmButtonColor: "#009688", cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar", cancelButtonText: "Cancelar"
        }).then(result => {
            if (!result.value) return;
            fetch(`/formatos/format_matrix_reports/${id}`, {
                method: 'DELETE',
                headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
            })
            .then(readJson)
            .then(response => {
                this.setState({ data: this.state.data.filter(item => item.id !== id) });
                this.messageSuccess(response);
            });
        });
    }

    toggleExpand = (report) => {
        if (this.state.expandedId === report.id) {
            this.setState({ expandedId: null });
        } else {
            this.setState({ expandedId: report.id, childMatrices: [] });
            this.loadChildMatrices(report.child_format_id);
        }
    }

    // --- refresca una config puntual dentro de la lista ---
    replaceReport = (reportId, mutate) => {
        this.setState({
            data: this.state.data.map(r => r.id === reportId ? mutate({ ...r }) : r)
        });
    }

    // --- Campos generales (preguntas del PADRE) ---
    addField = (report) => {
        const q = this.state.newFieldQuestion;
        if (!q) return;

        fetch('/formatos/format_matrix_report_fields', {
            method: 'POST',
            body: JSON.stringify({
                format_matrix_report_id: report.id,
                question_id: q.value,
                label: this.state.newFieldLabel || q.label,
            }),
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
        .then(readJson)
        .then(data => {
            if (!data.register) return this.messageSuccess(data);
            this.replaceReport(report.id, r => ({ ...r, fields: [...r.fields, data.register] }));
            this.setState({ newFieldQuestion: null, newFieldLabel: "" });
        });
    }

    deleteField = (report, fieldId) => {
        fetch(`/formatos/format_matrix_report_fields/${fieldId}`, {
            method: 'DELETE',
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
        .then(readJson)
        .then(() => this.replaceReport(report.id, r => ({ ...r, fields: r.fields.filter(f => f.id !== fieldId) })));
    }

    // --- Matrices (preguntas del HIJO) ---
    addMatrix = (report) => {
        const q = this.state.newMatrixQuestion;
        if (!q) return;

        fetch('/formatos/format_matrix_report_matrices', {
            method: 'POST',
            body: JSON.stringify({ format_matrix_report_id: report.id, question_id: q.value }),
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
        .then(readJson)
        .then(data => {
            if (!data.register) return this.messageSuccess(data);
            this.replaceReport(report.id, r => ({ ...r, matrices: [...r.matrices, data.register] }));
            this.setState({ newMatrixQuestion: null });
        });
    }

    deleteMatrix = (report, matrixId) => {
        fetch(`/formatos/format_matrix_report_matrices/${matrixId}`, {
            method: 'DELETE',
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
        .then(readJson)
        .then(() => this.replaceReport(report.id, r => ({ ...r, matrices: r.matrices.filter(m => m.id !== matrixId) })));
    }

    // Guarda la abreviatura de una columna. Se escribe en el state al teclear y
    // se persiste al salir del input.
    changeAbbreviation = (report, matrix, column, value) => {
        this.replaceReport(report.id, r => ({
            ...r,
            matrices: r.matrices.map(m => m.id === matrix.id
                ? { ...m, abbreviations: { ...m.abbreviations, [column]: value } }
                : m)
        }));
    }

    saveAbbreviations = (report, matrixId) => {
        const current = this.state.data.find(r => r.id === report.id);
        const matrix = current && current.matrices.find(m => m.id === matrixId);
        if (!matrix) return;

        fetch(`/formatos/format_matrix_report_matrices/${matrixId}`, {
            method: 'PATCH',
            body: JSON.stringify({ abbreviations: matrix.abbreviations || {} }),
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
        .then(readJson)
        .then(data => { if (data.register) this.replaceReport(report.id, r => ({
            ...r, matrices: r.matrices.map(m => m.id === data.register.id ? data.register : m)
        })); });
    }

    toggleStep = (report, step, isOn) => {
        if (isOn) {
            const current = (report.steps || []).find(x => String(x.step_id) === String(step.id));
            if (!current) return;
            fetch(`/formatos/format_matrix_report_steps/${current.id}`, {
                method: 'DELETE',
                headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
            })
            .then(readJson)
            .then(() => this.replaceReport(report.id, r => ({
                ...r, steps: r.steps.filter(x => x.id !== current.id)
            })));
        } else {
            fetch('/formatos/format_matrix_report_steps', {
                method: 'POST',
                body: JSON.stringify({ format_matrix_report_id: report.id, step_id: step.id }),
                headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
            })
            .then(readJson)
            .then(data => {
                if (!data.register) return this.messageSuccess(data);
                this.replaceReport(report.id, r => ({ ...r, steps: [...(r.steps || []), data.register] }));
            });
        }
    }

    changeReportAbbreviation = (report, key, value) => {
        this.replaceReport(report.id, r => ({
            ...r, abbreviations: { ...(r.abbreviations || {}), [key]: value }
        }));
    }

    saveReportAbbreviations = (reportId) => {
        const current = this.state.data.find(r => r.id === reportId);
        if (!current) return;
        fetch(`/formatos/format_matrix_reports/${reportId}`, {
            method: 'PATCH',
            body: JSON.stringify({ abbreviations: current.abbreviations || {} }),
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        }).then(readJson);
    }

    addAbbreviationRow = (report) => {
        const key = (this.state.newAbbrKey || "").trim();
        if (!key) return;
        this.replaceReport(report.id, r => ({
            ...r, abbreviations: { ...(r.abbreviations || {}), [key]: this.state.newAbbrValue || "" }
        }));
        this.setState({ newAbbrKey: "", newAbbrValue: "" }, () => this.saveReportAbbreviations(report.id));
    }

    availableMatrixOptions = (report) => {
        const used = (report.matrices || []).map(m => String(m.question_id));
        return this.state.childMatrices
            .filter(m => !used.includes(String(m.id)))
            .map(m => ({ label: `${m.question} (${m.items_count} ítems)`, value: m.id }));
    }

    renderDetail = (report) => {
        const styeleIcons = { fontSize: "14px", color: "#3f69d8", cursor: "pointer" };

        return (
            <div style={{ padding: '10px 16px', borderTop: '1px solid #e5e7eb' }}>
                <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 6 }}>Información general (preguntas de este formato)</div>

                {(report.fields || []).map(field => (
                    <div key={field.id} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                        <span style={{ fontSize: 12, flex: 1 }}>
                            <b>{field.label || field.question_name}</b>
                            <span style={{ color: '#999' }}> — {field.question_name}</span>
                        </span>
                        <i className="fas fa-trash-alt" style={styeleIcons} onClick={() => this.deleteField(report, field.id)} />
                    </div>
                ))}

                <div className="row" style={{ marginTop: 6 }}>
                    <div className="col-md-6">
                        <Select
                            onChange={(o) => this.setState({ newFieldQuestion: o })}
                            options={this.state.parentQuestions}
                            value={this.state.newFieldQuestion}
                            placeholder="Pregunta del formato..."
                            classNamePrefix="select" isClearable
                        />
                    </div>
                    <div className="col-md-4">
                        <input type="text" className="rk-input" placeholder="Etiqueta en el PDF"
                            value={this.state.newFieldLabel}
                            onChange={(e) => this.setState({ newFieldLabel: e.target.value })} />
                    </div>
                    <div className="col-md-2">
                        <button className="rk-btn rk-btn--primary" onClick={() => this.addField(report)}>Agregar</button>
                    </div>
                </div>

                <hr className="rk-divider" />

                {report.row_source === "steps" ? this.renderStepsConfig(report) : this.renderMatricesConfig(report)}
            </div>
        );
    }

    // --- Modo SECCIONES: checkboxes (todas marcadas al crear) + abreviaturas globales ---
    renderStepsConfig = (report) => {
        const selected = (report.steps || []);
        const abbr = report.abbreviations || {};

        return (
            <React.Fragment>
                <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 6 }}>Secciones a incluir (del formato diario)</div>

                {this.state.childSteps.length === 0 && (
                    <small className="validate-label">
                        Este formato no tiene secciones con preguntas de selección.
                    </small>
                )}

                {this.state.childSteps.map(step => {
                    const isOn = selected.some(x => String(x.step_id) === String(step.id));
                    return (
                        <div key={step.id} className="custom-control custom-switch" style={{ marginBottom: 6 }}>
                            <input
                                type="checkbox"
                                className="custom-control-input"
                                id={`fmr-step-${report.id}-${step.id}`}
                                checked={isOn}
                                onChange={() => this.toggleStep(report, step, isOn)}
                            />
                            <label className="custom-control-label" htmlFor={`fmr-step-${report.id}-${step.id}`}>
                                {step.name} <small className="validate-label">({step.questions_count} preguntas)</small>
                            </label>
                        </div>
                    );
                })}

                <hr className="rk-divider" />

                <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 2 }}>Abreviaturas</div>
                <small className="validate-label">
                    Se aplican a todas las secciones: lo que aparece en el cuadrito de cada día.
                </small>

                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, margin: '8px 0' }}>
                    {Object.keys(abbr).map(key => (
                        <div key={key} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <span style={{ fontSize: 12 }}>{key}</span>
                            <input
                                type="text"
                                className="rk-input rk-input--inline"
                                style={{ width: 64 }}
                                value={abbr[key] || ""}
                                onChange={(e) => this.changeReportAbbreviation(report, key, e.target.value)}
                                onBlur={() => this.saveReportAbbreviations(report.id)}
                            />
                        </div>
                    ))}
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <input type="text" className="rk-input" placeholder="Valor de la respuesta (ej. Bueno)"
                            value={this.state.newAbbrKey || ""}
                            onChange={(e) => this.setState({ newAbbrKey: e.target.value })} />
                    </div>
                    <div className="col-md-4">
                        <input type="text" className="rk-input" placeholder="Abreviatura (ej. B)"
                            value={this.state.newAbbrValue || ""}
                            onChange={(e) => this.setState({ newAbbrValue: e.target.value })} />
                    </div>
                    <div className="col-md-2">
                        <button type="button" className="rk-btn rk-btn--primary"
                            onClick={() => this.addAbbreviationRow(report)}>Agregar</button>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    // --- Modo MATRICES (original) ---
    renderMatricesConfig = (report) => {
        const styeleIcons = { fontSize: "14px", color: "#3f69d8", cursor: "pointer" };

        return (
            <React.Fragment>
                <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 6 }}>Matrices a incluir (del formato diario)</div>

                {(report.matrices || []).map(matrix => (
                    <div key={matrix.id} className="rk-panel mb-2" style={{ padding: '10px 12px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span style={{ fontSize: 12, flex: 1, fontWeight: 600 }}>{matrix.label || matrix.question_name}</span>
                            <button type="button" className="rk-icon-btn rk-icon-btn--cancel"
                                onClick={() => this.deleteMatrix(report, matrix.id)}>
                                <i className="fas fa-trash-alt"></i>
                            </button>
                        </div>

                        <small className="validate-label">
                            Abreviatura por columna (lo que aparece en el cuadrito de cada día)
                        </small>

                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 6 }}>
                            {(matrix.columns || []).length === 0 && (
                                <span style={{ fontSize: 11, color: '#999' }}>Esta matriz no tiene columnas configuradas.</span>
                            )}
                            {(matrix.columns || []).map(column => (
                                <div key={column} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                    <span style={{ fontSize: 12 }}>{column}</span>
                                    <input
                                        type="text"
                                        className="rk-input rk-input--inline"
                                        style={{ width: 64 }}
                                        value={(matrix.abbreviations && matrix.abbreviations[column]) || ""}
                                        onChange={(e) => this.changeAbbreviation(report, matrix, column, e.target.value)}
                                        onBlur={() => this.saveAbbreviations(report, matrix.id)}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}

                <div className="row" style={{ marginTop: 6 }}>
                    <div className="col-md-10">
                        <Select
                            onChange={(o) => this.setState({ newMatrixQuestion: o })}
                            options={this.availableMatrixOptions(report)}
                            value={this.state.newMatrixQuestion}
                            placeholder="Matriz del formato diario..."
                            classNamePrefix="select" isClearable
                        />
                    </div>
                    <div className="col-md-2">
                        <button className="rk-btn rk-btn--primary" onClick={() => this.addMatrix(report)}>Agregar</button>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    render() {
        const styeleIcons = { fontSize: "16px", color: "#3f69d8", cursor: "pointer" };

        return (
            <React.Fragment>
                <Modal isOpen={this.props.modal} toggle={this.props.toggle} className="modal-dialog-centered modal-lg rk-modal" backdrop={this.props.backdrop}>
                    <div className="rk-modal__header">
                        <span className="rk-modal__header-icon"><i className="fas fa-table"></i></span>
                        <h5>{this.props.title}</h5>
                        <button type="button" className="rk-modal__close" onClick={() => this.props.toggle()}>
                            <i className="fas fa-times"></i>
                        </button>
                    </div>

                    <div className="rk-modal__body">
                        {this.state.showForm && !this.state.modeEdit && (
                            <FormCreate
                                key="new"
                                format={this.props.format}
                                formatos={this.props.formatos}
                                modeEdit={false}
                                register={null}
                                onCreated={this.handleCreated}
                                onUpdated={this.handleUpdated}
                                onClose={() => this.setState({ showForm: false, modeEdit: false, editRegister: null })}
                            />
                        )}

                        <div className="col-md-12 mb-3 text-right pr-0">
                            {!this.state.showForm && (
                                <button className="rk-btn rk-btn--primary"
                                    onClick={() => this.setState({ showForm: true, modeEdit: false, editRegister: null })}>
                                    <i className="fas fa-plus mr-1" /> Nueva configuración
                                </button>
                            )}
                        </div>

                        {this.state.data.length >= 1 ? (
                            this.state.data.map(report => (
                                <div className="rk-panel mb-3" key={report.id}>
                                    {this.state.modeEdit && this.state.editRegister && this.state.editRegister.id === report.id ? (
                                        <FormCreate
                                            key={`edit-${report.id}`}
                                            format={this.props.format}
                                            formatos={this.props.formatos}
                                            modeEdit={true}
                                            register={report}
                                            onCreated={this.handleCreated}
                                            onUpdated={this.handleUpdated}
                                            onClose={() => this.setState({ showForm: false, modeEdit: false, editRegister: null })}
                                        />
                                    ) : (
                                        <React.Fragment>
                                            <div style={{ padding: '12px 16px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <div>
                                                        <div style={{ fontWeight: 600, fontSize: 14 }}>{report.name}</div>
                                                        <div style={{ fontSize: 12, color: '#999' }}>
                                                            Registros diarios: {report.child_format_name || '-'} ·
                                                            {" "}{(report.matrices || []).length} matrices ·
                                                            {" "}{(report.fields || []).length} campos generales
                                                        </div>
                                                    </div>
                                                    <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                                                        <button type="button" className="rk-icon-btn" onClick={() => this.toggleExpand(report)}>
                                                            <i className={`fas fa-chevron-${this.state.expandedId === report.id ? 'up' : 'down'}`} />
                                                        </button>
                                                        <button type="button" className="rk-icon-btn"
                                                            onClick={() => this.setState({ showForm: true, modeEdit: true, editRegister: report })}>
                                                            <i className="fas fa-pencil-alt" />
                                                        </button>
                                                        <button type="button" className="rk-icon-btn rk-icon-btn--cancel"
                                                            onClick={() => this.handleDelete(report.id)}>
                                                            <i className="fas fa-trash-alt" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            {this.state.expandedId === report.id && this.renderDetail(report)}
                                        </React.Fragment>
                                    )}
                                </div>
                            ))
                        ) : (
                            <div className="rk-empty">
                                <i className="fas fa-table"></i>
                                <p>No hay configuraciones</p>
                                <small>Crea una para generar el reporte de matrices por período.</small>
                            </div>
                        )}
                    </div>

                    <div className="rk-modal__footer">
                        <button type="button" className="rk-btn rk-btn--ghost" onClick={() => this.props.toggle()}>
                            Cerrar
                        </button>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}

export default Index;
